var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      class: _vm.componentClass,
      style: _vm.componentStyle,
      attrs: {
        "aria-label": _vm.tooltipText,
        "data-balloon-pos": _vm.tooltipPosition,
      },
    },
    [_vm._v(_vm._s(_vm.title))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }